// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"feb62141","235":"31b210fa","329":"49609c0f","364":"e17fffc2","925":"8dfe8ccc"}[chunkId] + ".css";
};